__turbopack_context__.v({
  "container": "OrderTimeSelectionTimezoneTag-module-scss-module__wPI5CG__container",
  "standard": "OrderTimeSelectionTimezoneTag-module-scss-module__wPI5CG__standard",
  "summer": "OrderTimeSelectionTimezoneTag-module-scss-module__wPI5CG__summer",
});
